import { AddOn } from './AddOn';

export class Marketo extends AddOn {
  public get shortDescription(): string {
    return 'Create and update contacts in Marketo with interaction responses, behavioral data, and more for all your webinar registrants.';
  }

  public get description(): string {
    return 'Create and update contacts in Marketo with interaction responses, behavioral data, and more for all your webinar registrants.';
  }

  public image(): string | null {
    return require('$/images/logos/big-marketo.png').default;
  }
}
